import { render, staticRenderFns } from "./_dates.vue?vue&type=template&id=4b7f2c98&"
import script from "./_dates.vue?vue&type=script&lang=js&"
export * from "./_dates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports